import { MessageCircle } from "lucide-react";
import { useConfig } from "../../lib/config";
import { waLink } from "../../lib/api";

export function WhatsAppFloat() {
  const config = useConfig();
  if (!config.whatsapp_number) return null;
  return (
    <a
      href={waLink(config.whatsapp_number, "Hola, quiero consultar sobre productos AZOO.")}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Consultar por WhatsApp"
      className="fixed bottom-5 right-5 z-50 w-14 h-14 rounded-full bg-brand-500 hover:bg-brand-600 text-white flex items-center justify-center shadow-lg shadow-brand-600/30 transition-colors"
      data-testid="whatsapp-float-button"
    >
      <MessageCircle className="w-7 h-7" />
    </a>
  );
}
